import {ApiClient} from '@hconnect/apiclient'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'

type Variables = {plantCode: string; materialId: number; isActive: boolean}

export const useUpdateMaterialStatus = ({
  onError,
  onSuccess,
  onSettled
}: {
  onError?: (error: AxiosError, variables: Variables) => void
  onSuccess?: (data: void, variables: Variables) => void
  onSettled?: (data: void | undefined, error: AxiosError | null, variables: Variables) => void
} = {}) =>
  useMutation<void, AxiosError, Variables>({
    mutationKey: ['materials'],
    mutationFn: async ({plantCode, materialId, isActive}) => {
      await ApiClient.axiosInstance.patch<void>(
        `/plants/${plantCode}/materials/${materialId}/is-active`,
        {isActive}
      )
    },
    onError,
    onSuccess,
    onSettled
  })
